import React from 'react';
import { IconType, IconBaseProps } from 'react-icons';

interface IconProps {
  icon: IconType;
  className?: string;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps> = ({ icon, className, style }) => {
  // Cast the icon to a specific component type that React.createElement can accept
  const IconComponent = icon as React.ComponentType<IconBaseProps>;
  return <IconComponent className={className} style={style} />;
};

export default Icon; 